<template>
<!-- <div></div> -->
    <div class="card card-dashboard-fourteen" style="height:210px" v-loading='loading'>
        <label class="az-content-label">Contributions</label>
        <div class="card-body">
            <div class="row mg-t-15 mg-b-20">
            <div class="col">
                <h4>{{member_number}}</h4><label class="lb">{{member_number>1 || member_number===0?"Members":"Member"}}</label>
                <span>{{text}}</span>
                
            </div>
            </div>
        </div>
        <div class="card-footer">
            <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/contributions",query:{page:"Contributions"}}' style="font-size:12px;font-weight:600"><i class="fa fa-angle-right"></i>Contributions</router-link>
        </div>
    </div> 
</template>
<script>
export default {
    name:"contributions",
    data(){
        return{
            member_number:'',
            members:[],
            text:'',
            loading:true
        }
    },
    created(){
        this.getContributionData();
    },
    methods:{
        getContributionData: function(){
            // will change when BO router set up
            // let brand = this.$route.params.brand;
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.contributionInfo(brand).then(response =>{
                //get the investments data from response
                let contribution = response.data["contributions"];
                let exceeded_contribution = response.data["exceeded_contributions"]
                if(exceeded_contribution.length>0){
                    this.members = exceeded_contribution
                    this.member_number = exceeded_contribution.length
                    this.text = 'may have breached the cap'
                }else if(contribution.length>0){
                    this.members = contribution
                    this.member_number = contribution.length
                    this.member_number===1?this.text = 'is within 10% of breaching the cap'
                    :this.text = 'are within 10% of breaching the cap'
                }else{
                    this.member_number = 0
                    this.text = 'are within 10% of breaching the cap'
                }
                this.loading=false
            })
            
        }
    }
}
</script>
<style scoped>
.lb{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>